import { render } from "./arrangeDialog.vue?vue&type=template&id=9fd9955a&scoped=true"
import script from "./arrangeDialog.vue?vue&type=script&lang=js"
export * from "./arrangeDialog.vue?vue&type=script&lang=js"

import "./arrangeDialog.vue?vue&type=style&index=0&id=9fd9955a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd9955a"]])

export default __exports__